var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bids-add-bulk-drop-loading"},[_c('div',{staticClass:"bids-add-bulk-drop-loading__progress"},[_c('HollowDotsSpinner',{attrs:{"animation-duration":1000,"dot-size":12,"dots-num":3,"color":'#95a5a6'}})],1),_vm._v(" "),_c('span',{staticClass:"bids-add-bulk-drop-loading__text"},[_vm._v("\n    "+_vm._s(_vm.$t('ADVERTISEMENT.BULK_IMPORT.PROCESS_PROGRESS', {
        fileName: _vm.fileName,
      }))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }